import { render, staticRenderFns } from "./NewPageModal.vue?vue&type=template&id=92884ad4"
import script from "./NewPageModal.vue?vue&type=script&lang=js"
export * from "./NewPageModal.vue?vue&type=script&lang=js"
import style0 from "./NewPageModal.vue?vue&type=style&index=0&id=92884ad4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports